import { Autocomplete, TextField } from "@mui/material";
import { Controller } from "react-hook-form";

interface IFormInput {
    name: string;
    label: string;
    control: any;
    error: any;
    disabled?: boolean;
    options: { value: string | number; label: string }[];
    concatWithID?: boolean;
    limitTags?: number;
    filterOptions?: any;
    onChange?: any;
    disableCloseOnSelect?: boolean;
}

export default function AutoCompleteComponent({
    name,
    label,
    options,
    control,
    error,
    disabled,
    concatWithID: concat,
    onChange,
    limitTags,
    filterOptions,
    disableCloseOnSelect,
}: IFormInput) {
    return (
        <Controller
            name={name}
            control={control}
            defaultValue={[]}
            render={({ field: { onChange: renderChange, value: valueProp } }) => {
                return (
                    <Autocomplete
                        openText="Abrir"
                        closeText="Fechar"
                        multiple
                        size="small"
                        limitTags={limitTags}
                        disabled={disabled}
                        options={options}
                        filterOptions={filterOptions}
                        disableCloseOnSelect={disableCloseOnSelect}
                        value={valueProp || []}
                        getOptionLabel={(opt) => {
                            if (concat) {
                                if (typeof opt === "object") {
                                    return `${opt.value} - ${opt?.label}`;
                                }
                                if (typeof opt === "string") {
                                    return options.find((op) => String(op.value) === String(opt))?.label || opt;
                                }
                            }

                            return opt?.label || options.find((op) => String(op.value) === String(opt))?.label || opt;
                        }}
                        isOptionEqualToValue={(option, value) => {
                            return String(option.value) === String(value);
                        }}
                        onChange={(_, value) => {
                            const newValue = !!value
                                ? value.map((opt) => {
                                      const isNewValueString = typeof opt === "string";
                                      return isNewValueString ? opt : String(opt.value);
                                  })
                                : [];
                            renderChange(newValue);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                margin="normal"
                                size="small"
                                error={!!error && !!error[name]}
                                helperText={!!error && error[name]?.message}
                                label={label}
                                placeholder={label}
                            />
                        )}
                    />
                );
            }}
        />
    );
}
